// extracted by mini-css-extract-plugin
module.exports = {"advantage":"Advantage_advantage__BAB4O","iconContainer":"Advantage_iconContainer__LWA27"};